import Vue from 'vue'
import Vuex from 'vuex'

import cart from './modules/cart'
import products from './modules/products'
import auth from './modules/auth'
import messages from './modules/messages'
import shop from './modules/shop'
import orders from './modules/orders'
import stores from './modules/stores'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    shop,
    cart,
    products,
    messages,
    orders,
    stores
  },
  plugins: [createPersistedState({ paths: ['cart'] })]
})
